import React, { useState, useEffect } from "react";
import TableOne from "./TableOne";
import TableTwo from "./TableTwo";

const ScoringDetails = ({ scoringData, onChangeRadio, error,protocolData }) => {
  const [transformedScoringData, setTransformedScoringData] = useState(null);

  const dataCheck = Object.keys(scoringData).length > 0;

  function transformFsscResult(data) {
    return [
      {
        id: 1,
        results: "Criticals",
        numOfNonComf: data?.critical?.toString() ?? "N/A",
        nonComfPoints: data?.criticalScore?.toString() ?? "N/A",
      },
      {
        id: 2,
        results: "Majors",
        numOfNonComf: data?.major?.toString() ?? "N/A",
        nonComfPoints: data?.majorScore?.toString() ?? "N/A",
      },
      {
        id: 3,
        results: "Minors",
        numOfNonComf: data?.minor?.toString() ?? "N/A",
        nonComfPoints: data?.minorScore?.toString() ?? "N/A",
      },
    ];
  }
  function transformAuditConclusion(
    obj1,
    obj2,
    obj3,
    obj4,
    obj5,
    obj6,
    obj7,
    obj8
  ) {
    return [
      {
        id: "fsscCertification",
        label: "Will be recommended for FSSC Certification? ",
        value: obj1 ?? "N/A",
        verificationStatus: "Verified",
      },
      {
        id: "conformanceLevel",
        label: "Mars QMS Audit Conformance Level:",
        value: obj2 ?? "N/A",
        verificationStatus: "Verified",
      },
      {
        id: "areaStrength",
        label:
          "Areas of Strength - Identify minimum 2 areas of strength for the unit and why",
        value: obj3 ?? "N/A",
        verificationStatus: "Verified",
      },
      {
        id: "areaOpportunity",
        label:
          "Areas of Opportunity -  Identify minimum 2 areas of opportunity for the unit and why",
        value: obj4 ?? "N/A",
        verificationStatus: "Verified",
      },
      {
        id: "zeroFindingJustification",
        label:
          "If this audit had zero findings - please justify the unit's success to share for learnings.",
        value: obj5 ?? "N/A",
        verificationStatus: "Verified",
      },
      {
        id: "auditDuration",
        label: "Audit Duration",
        value: (obj6 ? `${obj6} Hours` : "") + (obj7 ? ` ${obj7} Minutes` : ""),
        verificationStatus: "Verified",
      },
    
    ];
  }

  useEffect(() => {
    if (dataCheck) {
      let fsscResultData = transformFsscResult(scoringData?.fsscScore[0]);
      let qmsResultData = transformFsscResult(scoringData?.qmsScore[0]);
      let auditConclustion = scoringData?.auditConclusion;
      let auditConclusionData = transformAuditConclusion(
        scoringData?.isFsscConjuction === false ? 'N/A' : auditConclustion?.isFfscCertificationRecommended === 1  ? 'Yes': auditConclustion?.isFfscCertificationRecommended === 0 ? 'No':  auditConclustion?.isFfscCertificationRecommended === 2 ? "Pending Corrective Action Review" : 'N/A',
        auditConclustion?.conformanceLevel,
        auditConclustion?.areaStrength,
        auditConclustion?.areaOpportunity,
        auditConclustion?.zeroFindingJustification,
        auditConclustion?.auditDurationHour,
        auditConclustion?.auditDurationMinutes,
        auditConclustion?.isTechReviewDone
      );

      setTransformedScoringData((prev) => {
        return {
          ...prev,
          fsscResultData: fsscResultData,
          qmsResultData: qmsResultData,
          auditConclusionData: auditConclusionData,
        };
      });
    } else {
      setTransformedScoringData(null);
    }
  }, [scoringData]);

  const radioButtonHandler = (id, changedData, tabName, status) => {
    onChangeRadio(id, changedData, tabName, status);
  };

// console.log("transformedScoringData",transformedScoringData)
  return (
    <div>
      
      <TableOne
        formDetails={
          transformedScoringData ? transformedScoringData?.qmsResultData : []
        }
        error={error}
        firstColumn="QMS Results (Full Audit or Addendum)"
      />

    {protocolData && protocolData['fsscFindings'] && protocolData['fsscFindings'].length !==0 && (

        <TableOne
            formDetails={
              transformedScoringData ? transformedScoringData?.fsscResultData : []
            }
            error={error}
            firstColumn="FSSC Results (if applicable)"
          />
        )}
      {!error && (
        <div>
          <table style={{ width: "96%", margin: "auto" }}>
            <thead>
              <tr>
                <th
                  style={{
                    width: "75%",
                    padding: "7px 40px",
                    border: "1px solid #d4d4d4",
                    height: "93px",
                    fontSize: "16px",
                    color: "#262626",
                  }}
                >
                  Non Conformance Score
                </th>
                <th
                  style={{
                    width: "25%",
                    padding: "7px 40px",
                    border: "1px solid #d4d4d4",
                    height: "93px",
                    fontSize: "16px",
                    color: "#262626",
                    textAlign: "center",
                  }}
                >
                  {dataCheck &&
                    scoringData?.fsscScore[0]?.totalNonConformanceScore +
                      scoringData?.qmsScore[0]?.totalNonConformanceScore}
                </th>
              </tr>
            </thead>
          </table>
        </div>
      )}

      <TableTwo
        formDetails={
          transformedScoringData
            ? transformedScoringData?.auditConclusionData
            : []
        }
        error={error}
        tabName="auditConclusionData"
        onRadioChange={radioButtonHandler}
      />
    </div>
  );
};

export default ScoringDetails;
